import React from "react";
import "./App.css";
import {Route, Routes} from "react-router-dom";

import {history} from "./_helpers";
import {DefaultLayout} from "./containers";

// Styles
// CoreUI Icons Set
import "@coreui/icons/css/all.css";
// Import Flag Icons Set
import "flag-icon-css/css/flag-icons.min.css";
// Import Font Awesome Icons Set
import "@fortawesome/fontawesome-free/css/solid.css";
import "@fortawesome/fontawesome-free/css/brands.css";
import "@fortawesome/fontawesome-free/css/fontawesome.css";

// Import Simple Line Icons Set
import "simple-line-icons/css/simple-line-icons.css";
// Import Main styles for this application
import "./scss/style.css";
import {PrivateRoute} from "./_components";
import {CustomRouter} from "./containers/CustomRouter";
import InvoiceTemplate from "./InvoiceTemplate/InvoiceTemplate";
import CreditNoteTemplate from "./CreditNoteTemplate/CreditNoteTemplate";

const App = () => {
    return (
        <CustomRouter history={history}>
            <Routes>
                <Route path="/invoicing/i/:id" element={<InvoiceTemplate/>}/>
                <Route path="/invoicing/i" element={<InvoiceTemplate/>}/>
                <Route path="/invoicing/cn/:id/:refundId" element={<CreditNoteTemplate/>}/>
                <Route path="/invoicing/cn" element={<CreditNoteTemplate/>}/>
                <Route path="*" element={<PrivateRoute/>}>
                    <Route path="*" element={<DefaultLayout/>}/>
                </Route>
            </Routes>
        </CustomRouter>
    );
}

export default App